import React from 'react';

interface ITPartnerSupplierConfigurationProps {
    configuration: {
        BaseUrl?: string;
        ProductsPath?: string;
    };
    onChange: (field: string, value: string | number) => void;
    disabled?: boolean;
}

interface ITPartnerConfigurationComponent extends React.FC<ITPartnerSupplierConfigurationProps> {
    configFields: string[];
}

const ITPartnerConfiguration: ITPartnerConfigurationComponent = ({
    configuration,
    onChange,
    disabled = false
}) => {
    return (
        <React.Fragment>
            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">🌐</span>
                    Базовый URL
                </label>
                <div className="input-group-custom">
                    <input
                        type="url"
                        className="form-input-custom"
                        value={configuration.BaseUrl || ''}
                        onChange={(e) => onChange('BaseUrl', e.target.value)}
                        placeholder="https://api.itpartner.example.com"
                        disabled={disabled}
                    />
                </div>
            </div>

            <div className="form-group-custom">
                <label className="form-label-custom">
                    <span className="label-icon">�</span>
                    Путь к продуктам
                </label>
                <div className="input-group-custom">
                    <input
                        type="text"
                        className="form-input-custom"
                        value={configuration.ProductsPath || ''}
                        onChange={(e) => onChange('ProductsPath', e.target.value)}
                        placeholder="/api/products"
                        disabled={disabled}
                    />
                </div>
            </div>
        </React.Fragment>
    );
};

// Define the configuration fields used by this supplier
ITPartnerConfiguration.configFields = ['BaseUrl', 'ProductsPath'];

export default ITPartnerConfiguration;
